import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import webhooksSendMessages from './webhooksSendMessages.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import closingReasons from './closingReasons.json';
import campaignsReport from './campaignsReport.json';
import c2wCampaignsReport from './c2wCampaignsReport.json';
import callLogReport from './callLogReport.json';
import apiErrorsReport from './apiErrorsReport.json';
import templateEventsReport from './templateEventsReport.json';
import whatsappConsumptionsReport from './whatsappConsumptionsReport.json';
import virtualAssistantConsumptionsReport from './virtualAssistantConsumptionsReport.json';
import operationalDashboard from './operationalDashboard.json';
import labelsReport from './labelsReport.json';
import ctwaHistory from './ctwaHistory.json';
import conditions from './conditions.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import internalChat from './internalChat.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import productLabelsMgmt from './productLabelsMgmt.json';
import topicLabelsMgmt from './topicLabelsMgmt.json';
import concurrentLabelsMgmt from './concurrentLabelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import scheduledMessage from './scheduledMessage.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import templateParameterization from './templateParameterization.json';
import whatsappTemplates from './whatsappTemplates.json';
import dashboardAppsfrom from './dashboardApps.json';
import securityPolicies from './securityPolicies.json';
import blockAccessUserAccountfrom from './blockAccessUserAccount.json';
import agentBotManagement from './agentBotManagement.json';
import priorityContact from './priorityContact.json';
import upcomingScheduledMessages from './upcomingScheduledMessages.json';
import cadencias from './cadencias.json';
import events from './events.json';
import builder from './builder.json';
import call from './call.json';
import _subaccounts from './subaccounts.json';
import opportunityPipelines from './opportunityPipelines.json';
import opportunityDetails from './opportunityDetails.json';
import activityAgenda from './activityAgenda.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...webhooksSendMessages,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...closingReasons,
  ...campaignsReport,
  ...c2wCampaignsReport,
  ...callLogReport,
  ...apiErrorsReport,
  ...templateEventsReport,
  ...whatsappConsumptionsReport,
  ...virtualAssistantConsumptionsReport,
  ...operationalDashboard,
  ...labelsReport,
  ...ctwaHistory,
  ...conditions,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...internalChat,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...productLabelsMgmt,
  ...topicLabelsMgmt,
  ...concurrentLabelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...scheduledMessage,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...teamsSettings,
  ...templateParameterization,
  ...whatsappTemplates,
  ...dashboardAppsfrom,
  ...securityPolicies,
  ...blockAccessUserAccountfrom,
  ...agentBotManagement,
  ...priorityContact,
  ...upcomingScheduledMessages,
  ...cadencias,
  ...events,
  ...builder,
  ...call,
  ..._subaccounts,
  ...opportunityPipelines,
  ...opportunityDetails,
  ...activityAgenda,
};
